<template>
    <!-- 社会功能开发课 -->
    <div class="shehuigongnengkaifake">
      <CertQuery :logo="Logo14" :type="'tba'" :color="'#294db0'" />
    </div>
  </template>
  
  <script>
  import CertQuery from '../component/certQuery.vue'
  import Logo14 from '@/assets/images/logo14.png'
  
  export default {
    name: 'SheHuiGongNengKaiFa',
    components: {
      CertQuery
    },
    data() {
      return {
        Logo14
      }
    }
  }
  </script>
  